import { useState, useEffect } from 'react';
import api from '../services/api';

export function useLegalSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/legal-settings')
      .then(res => { if (!cancelled) setSettings(res.data); })
      .catch(err => console.error('Erreur chargement mentions légales :', err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { settings, loading };
}

// Helper : retourne la valeur ou un placeholder si vide
export const orPlaceholder = (value, hint) => {
  if (value && value.trim()) return value;
  return `[À compléter : ${hint}]`;
};
